import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { tc } from '../../../lib/trackingContext';
import { useUser } from '../../useUser';
import { AccountDesignerPreferencesVertical } from '../../useDesigners';
import { GET_DESIGNER_PREFERENCES_QUERY } from '../useDesignerPreferences.rest';
import { UNFOLLOW_DESIGNER_MUTATION } from './useUnfollowDesigner.rest';

export const useUnfollowDesigner = (vertical: AccountDesignerPreferencesVertical) => {
  const { user } = useUser();

  const [mutate, { loading, error }] = useMutation(UNFOLLOW_DESIGNER_MUTATION);

  const unfollowDesigner = useCallback(
    (designerId: string, designerName: string | null) =>
      mutate({
        variables: {
          designerId: Number(designerId),
          userId: Number(user.id),
          vertical
        },
        refetchQueries: [
          {
            query: GET_DESIGNER_PREFERENCES_QUERY,
            variables: {
              userId: user.id,
              vertical
            }
          }
        ]
      }).then(() => {
        tc.track('Designer Unfollowed', {
          addToScopeOnce: {
            designerName,
            designerId,
            vertical
          },
          addToTrackingEvent: { label: designerName }
        });
      }),
    [mutate, user.id, vertical]
  );

  return {
    unfollowDesigner,
    loading,
    error
  };
};
